import React, { useState, useEffect } from 'react';
import PuenteApi from '../../../../../pageauth/PuenteApi';
import { QRCodeCanvas } from 'qrcode.react';

// Lista de tipos de tarjeta (se mantiene igual)
const TIPOS_TARJETA = ['Debito', 'Credito', 'QR'];

const PagoTarjetaForm = ({ 
    restaIngresar, 
    addPayment, 
    SetMensaje, 
    onCloseView, 
    integracion, 
    mediopago, 
    hayMasDeUnMedio, 
    setSelectedMedioPago, 
    selectedMedioPago,
    obtenerltimospagos,
    operarioID,
    verificarPermisoUsuario
}) => {
    
    const {CrearOrdenPago, ObtenerOrdenPorID, CrearOrdenPagoQrFisico} = PuenteApi()

    const montoRestante = restaIngresar.toFixed(2);
    const [importe, setImporte] = useState(montoRestante.replace('.', ',')); 
    const [nroTransferencia, setNroTransferencia] = useState('');
    const [tipoTarjeta, setTipoTarjeta] = useState('Debito'); // Valor por defecto
    const [cantcuotas, setCantcuotas] = useState('0');
    const [qruotrometodo, setQruotrometodo] = useState('');
    const [medioSeleccionado, setMedioSeleccionado] = useState(selectedMedioPago || '');
    const [showPopup, setShowPopup] = useState(false);
    const [selectedPago, setSelectedPago] = useState(null);

    const [ultimosPagos, setUltimosPagos] = useState([]); // Estado para los pagos
    const [loading, setLoading] = useState(false); // Estado para manejar la carga
    const [modoEdicion, setModoEdicion] = useState(false); // Estado para cambiar a modo de edición

    const [showPopupPDV, setShowPopupPDV] = useState(false);
    const [estadoPDV, setEstadoPDV] = useState('');

    const [qrData, setQrData] = useState('');
    const [qrImage, setQrImage] = useState('');
   

    const handlePagoSeleccionado = (pago) => {
        setNroTransferencia(pago.id);
        setImporte(pago.transaction_amount.toFixed(2).replace('.', ','));
        setShowPopup(false);
        if(pago.payment_method == "account_money"){
            setTipoTarjeta("Dinero disp en MP");
        }else if(pago.payment_method == "credit_card"){
            setTipoTarjeta("Credito");
            if(pago.last_four_digits && pago.last_four_digits !== 'N/A'){
                setCantcuotas(pago.installments);
            }
        }else{
            setTipoTarjeta("Debito");
        }
        setQruotrometodo(pago.qruotro);
    };

    // Función para manejar el pago
    const handlePagar = async(e) => {
        e.preventDefault();
        const importeNeto = parseFloat(importe.replace(',', '.'));

        if (importeNeto <= 0 || importeNeto > restaIngresar) {
            SetMensaje("Error", `El importe ($${importeNeto.toFixed(2).replace('.', ',')}) debe ser positivo y no exceder el restante.`, 2000);
            return;
        }
        if (integracion === "MercadoPago_automatico" && !nroTransferencia) {
            SetMensaje("Error", "Debe seleccionar un número de transferencia.", 2000);
            return;
        }

        let tipo=null;
        if(qruotrometodo == "QR"){
            tipo="QR";
        }else{
            tipo="TARJETA";
        }

        await addPayment({
            tipo: tipo,
            importe: importeNeto,
            nroTransferencia: nroTransferencia,
            detalle: `${tipoTarjeta}`, // Detalle para el JSON
            cuotas: cantcuotas
        });
    };


    useEffect(() => {
        if (mediopago.length >= 1 && !medioSeleccionado) {
            setMedioSeleccionado(mediopago[0].id);
        }
    }, [mediopago, medioSeleccionado, setSelectedMedioPago]);


    const obtenerUltimosPagos = async (pos_id, store_id) => {
        setLoading(true);  // Muestra el indicador de carga
        try {
            const data = await obtenerltimospagos(pos_id, store_id);
            if (data) {
                const pagos = data.map((pago) => ({
                    id: pago.id,
                    transaction_amount: pago.transaction_amount,
                    installments: pago.installments || 0,
                    last_four_digits: pago.card ? pago.card.last_four_digits : 'N/A',
                    payment_method: pago.payment_type_id,
                    qruotro: pago.point_of_interaction.business_info.branch,
                }));
                setUltimosPagos(pagos);
            } else {
                console.log('No se recibieron pagos.');
            }
        } catch (error) {
            console.error('Error al obtener pagos:', error);
        } finally {
            setLoading(false);  // Oculta el indicador de carga
        }
    };

    const setNroTransferencia_loc = (valor) => {
        if (modoEdicion){  setNroTransferencia(valor); }
    };

    const setImporte_loc = (valor) => {
        if (modoEdicion){  setImporte(valor); }
    };
     

    useEffect(() => {
        if (showPopup && medioSeleccionado) {
            const medioPagoSeleccionado2 = mediopago.find(medio => Number(medio.id) === Number(medioSeleccionado));
            if (medioPagoSeleccionado2) {
                const { pos_id, store_id } = medioPagoSeleccionado2;
                setUltimosPagos([])
                obtenerUltimosPagos(pos_id, store_id);
            }
        }
    }, [showPopup, medioSeleccionado]);


    const verificar_edicion_usuario = async() => {
        const resultado = await verificarPermisoUsuario(operarioID, "editarmontoventa");
        if(resultado == true){
            setModoEdicion(true);
        }
    };
    
    const verificar_pago_PDV = async(pos_id, store_id, importe, tipo_Tarjeta, id_op, intervalId) => {
        
        const resultado = await ObtenerOrdenPorID(id_op);
        if (resultado && resultado.status_detail === 'processed') {
            clearInterval(intervalId);
            setEstadoPDV("Pago Exitoso");
            let detalle = null;
            let cantcuotas = 1;

            if(resultado.transactions.payments[0].payment_method.type == "credit_card"){
                detalle = "Credito " + resultado.transactions.payments[0].payment_method.id;
                cantcuotas = resultado.transactions.payments[0].payment_method.installments;
            } else if(resultado.transactions.payments[0].payment_method.type == "debit_card"){
                detalle = "Debito " + resultado.transactions.payments[0].payment_method.id;
            } else{
                detalle = "Dinero disp en MP";
            }
            addPayment({
                tipo: "TARJETA",
                importe: resultado.transactions.payments[0].amount,
                nroTransferencia: resultado.transactions.payments[0].reference_id,
                detalle: detalle, // Detalle para el JSON
                cuotas: cantcuotas
            });
        } else if (resultado && resultado.status_detail === 'accredited') {
            clearInterval(intervalId);
            setEstadoPDV("Pago Exitoso");
            let detalle = null;
            let cantcuotas = 1;
            console.log(resultado)
            if(resultado.transactions.payments[0].payment_method.type == "credit_card"){
                detalle = "Credito " + resultado.transactions.payments[0].payment_method.id;
                cantcuotas = resultado.transactions.payments[0].payment_method.installments;
            } else if(resultado.transactions.payments[0].payment_method.type == "debit_card"){
                detalle = "Debito " + resultado.transactions.payments[0].payment_method.id;
            } else{
                detalle = "Dinero disp en MP";
            }

            addPayment({
                tipo: "QR",
                importe: resultado.transactions.payments[0].amount,
                nroTransferencia: resultado.transactions.payments[0].reference_id,
                detalle: detalle,
                cuotas: cantcuotas
            });
        } else if (resultado && resultado.status_detail === 'canceled') {
            clearInterval(intervalId);
            setEstadoPDV("Operacion cancelada desde terminal");
        } else if (resultado && resultado.status_detail === 'expired') {
            clearInterval(intervalId);
            setEstadoPDV("Operacion cancelada por tiempo maximo");
        } else if (resultado && resultado.status_detail === 'failed') {
            clearInterval(intervalId);
            setEstadoPDV("Error en el Pago");
        }
    };

    const procesarPago_PDV = async() => {
        const medioPagoSeleccionado2 = mediopago.find(medio => Number(medio.id) === Number(medioSeleccionado));

        if (medioPagoSeleccionado2) {
            setEstadoPDV("Generando Pago en terminal");
            setShowPopupPDV(true);
            const { pos_id, store_id } = medioPagoSeleccionado2;
            if(tipoTarjeta == "QR"){
                const respuesta = await CrearOrdenPagoQrFisico(pos_id, store_id, importe);
                if(respuesta){
                    // setQrData(respuesta.qr_data);
                    setQrImage('');
                    if (medioSeleccionado) {
                        const medioPagoSeleccionado2 = mediopago.find(medio => Number(medio.id) === Number(medioSeleccionado));
                        console.log(medioPagoSeleccionado2)
                        if (medioPagoSeleccionado2) {
                            const { qr_fisico} = medioPagoSeleccionado2;
                            const jsonObject = JSON.parse(qr_fisico);
                            setQrImage(jsonObject.image);
                        }
                    }
                    let intentos = 0;
                    const intervalId = setInterval(() => {
                        setEstadoPDV("Verificando Pago " + intentos + " de 30 segundos...");
                        verificar_pago_PDV(pos_id, store_id, importe, "QR", respuesta.idorden, intervalId);
                        intentos += 1;
                        if (intentos >= 30) {
                            clearInterval(intervalId);
                            setEstadoPDV("Tiempo de espera agotado");
                        }
                    }, 1000);
                }else{
                    SetMensaje("Error", "Error al generar pago", 3000);
                    setEstadoPDV("");
                    setShowPopupPDV(false);
                }
            }else{
                let tipo_Tarjeta=null;
                if(tipoTarjeta == "Debito"){
                    tipo_Tarjeta= "debit_card";
                }else{
                    tipo_Tarjeta= "credit_card";
                }
                const id_op = await CrearOrdenPago(pos_id, store_id, importe, tipo_Tarjeta);
                if(id_op){
                    let intentos = 0;
                    const intervalId = setInterval(() => {
                        setEstadoPDV("Verificando Pago " + intentos + " de 30 segundos...");
                        verificar_pago_PDV(pos_id, store_id, importe, tipo_Tarjeta, id_op, intervalId);
                        intentos += 1;
                        if (intentos >= 30) {
                            clearInterval(intervalId);
                            setEstadoPDV("Tiempo de espera agotado");
                        }
                    }, 1000);
                }else{
                    SetMensaje("Error", "Error al generar pago", 3000);
                    setEstadoPDV("");
                    setShowPopupPDV(false);
                }
            }
        }else{
            SetMensaje("Error", "No se encontro postnet", 3000);
        }
    };


    useEffect(() => {
        verificar_edicion_usuario();
        return 
    }, []);


    return (
       <>
            {hayMasDeUnMedio && (
                <div className="campo-pago">
                    <label htmlFor="medioPago">Seleccionar Medio de Pago:</label>
                    <select 
                        id="medioPago"
                        value={medioSeleccionado}
                        onChange={(e) => setMedioSeleccionado(e.target.value)}
                        required
                    >
                        {mediopago.map((medio) => (
                            <option key={medio.id} value={medio.id}>{medio.nombre}</option>
                        ))}
                    </select>
                </div>
            )}

            {/* Mostrar formularios específicos según la integración */}
            {integracion === "MercadoPago_automatico" && (
                 <form onSubmit={handlePagar} className="pago-form-container-tarjeta">
                    <div className="campo-pago">
                        <label htmlFor="nroTransferencia">Número de Transferencia: </label>
                        <div className="input-lupa-container">
                            <input 
                                id="nroTransferencia"
                                type="text"
                                value={nroTransferencia}
                                onChange={(e) => setNroTransferencia_loc(e.target.value)}
                                readOnly={!modoEdicion} 
                                required
                            />
                            <button 
                                type="button"
                                className="btn-lupa"
                                onClick={() => setShowPopup(true)}
                            >
                                🔍
                            </button>
                        </div>
                    </div>
                    <div className="campo-pago">
                        <label htmlFor="importeTarjeta">Importe a pagar en Tarjeta:</label>
                        <input 
                            id="importeTarjeta"
                            type="text"
                            value={importe}
                            readOnly={!modoEdicion} 
                            onChange={(e) => setImporte_loc(e.target.value.replace(/[^0-9,.]/g, ''))}
                            required
                        />  
                    </div>
                    <button type="submit" className="btn-agregar-pago">
                        + Agregar Pago
                    </button>
                </form>
            )}


            {integracion === "MercadoPago_PDV" && (
                <>
                    <div className="campo-pago">
                        <label htmlFor="tipoTarjeta">Tipo Tarjeta:</label>
                        <select 
                            id="tipoTarjeta"
                            value={tipoTarjeta}
                            onChange={(e) => setTipoTarjeta(e.target.value)}
                            required
                        >
                            {TIPOS_TARJETA.map(t => <option key={t} value={t}>{t}</option>)}
                        </select>
                    </div>
                    <div className="campo-pago">
                        <label htmlFor="importeTarjeta">Importe a pagar en Tarjeta:</label>
                        <input 
                            id="importeTarjeta"
                            type="text"
                            value={importe}
                            onChange={(e) => setImporte(e.target.value.replace(/[^0-9,.]/g, ''))}
                            required
                        />
                    </div>
                    <button className="btn-agregar-pago" onClick={() => procesarPago_PDV()}>
                        Cobrar
                    </button>
                </>
            )}

            {/* Si la integración es otra, mostrar un formulario genérico */}
            {integracion !== "MercadoPago_automatico" && integracion !== "MercadoPago_PDV" && (
                <div className="campo-pago">
                    <p>Este método de pago aún no está implementado.</p>
                </div>
            )}

            {showPopup && (
                <div className="popup-overlay">
                    <div className="popup-content">
                        <h3>Seleccionar un pago</h3>
                        {loading ? (
                            <center><p>Cargando pagos...</p></center>
                        ) : (
                            <div>
                                {ultimosPagos.length === 0 ? (
                                    <p>No hay pagos disponibles</p>  // Mensaje cuando no hay pagos
                                ) : (
                                    <ul className="payment-list">
                                        {ultimosPagos.map((pago) => (
                                            <li key={pago.id} className="payment-item">
                                                <button 
                                                    onClick={() => handlePagoSeleccionado(pago)}
                                                    className="payment-btn"
                                                >
                                                    $ {pago.transaction_amount.toFixed(2)} - {pago.id}

                                                    {/* Mostrar últimos 4 dígitos solo si están disponibles */}
                                                    {pago.last_four_digits && pago.last_four_digits !== 'N/A' && (
                                                        <>
                                                            <span className="payment-detail">
                                                                {' | Últimos 4 dígitos: ' + pago.last_four_digits}
                                                            </span>
                                                            <span className="payment-detail">
                                                                {' | Cuotas: ' + pago.installments}
                                                            </span>
                                                        </>
                                                    )}

                                                </button>
                                            </li>
                                        ))}
                                    </ul>
                                )}
                            </div>
                        )}
                        <button onClick={() => setShowPopup(false)} className="btn-close-popup">Cerrar</button>
                    </div>
                </div>
            )}

            {showPopupPDV && (
                <div className="popup-overlay">
                    <div className="popup-content">
                        <h3>Procesando pago</h3>
                        <br />
                        <center>{estadoPDV}</center>
                        <br />
                        {/* {qrData ? (
                            <QRCodeCanvas value={qrData} size={256} level="H" includeMargin={true} />
                        ) : (
                            <p>Cargando el QR...</p>
                        )} */}

                        {qrImage ? (
                            <img src={qrImage} alt="Código QR" style={{ width: '256px', height: '256px' }} />
                        ) : (
                            <p>Cargando el QR...</p>
                        )}

                        <br />
                        <button onClick={() => setShowPopupPDV(false)} className="btn-close-popup">Cerrar</button>
                    </div>
                </div>
            )}


        </>
    );
};

export default PagoTarjetaForm;
